import {
  FETCH_SMS_REJECTED,
  SIGNIN_SMS_VERIFICATION_REJECTED,
  SIGNIN_SMS_VERIFICATION_FORM_SHOW,
  SIGNIN_SMS_VERIFICATION_FORM_HIDE
} from "../constants/signinWithSms";

const initialState = {
  pending: true,
  error: {},
  redirect: false
};

export const signinWithSms = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SMS_REJECTED:
      return {
        ...state,
        pending: false,
        error: action.error
      };

    case SIGNIN_SMS_VERIFICATION_REJECTED:
      return {
        ...state,
        pending: false,
        error: action.data
      }

    case SIGNIN_SMS_VERIFICATION_FORM_SHOW:
      return {
        ...state,
        ...action.data,
        smsModalVisibility: true
      };

    case SIGNIN_SMS_VERIFICATION_FORM_HIDE:
      return {
        ...state,
        smsModalVisibility: false
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/signinWithSms.js